import React, { memo, useMemo } from 'react';
import { Label } from 'reactstrap';

export interface TableColumnProps extends React.HTMLAttributes<HTMLDivElement> {
  flex?: number;
  maxWidth?: number | string;
  minWidth?: number | string;
  width?: number;
  label?: boolean;
  noPadding?: boolean;
  bold?: boolean;
}

export const TableColumn = memo((props: TableColumnProps) => {
  const { flex = 1, maxWidth, minWidth, bold, children, width, style = {}, label = false, noPadding = false, ...rest } = props;
  const content = useMemo(() => (label ? <Label>{children}</Label> : children), [children, label]);
  return (
    <div
      {...rest}
      style={{ ...style, fontWeight: bold ? 'bold' : '', maxWidth, minWidth, width, flex, padding: noPadding ? undefined : '0px 5px 0px 5px' }}
    >
      {content}
    </div>
  );
});
